import {DATE_DIMENSIONS} from '../analytics.constants';
import {
  DimensionValue,
  MetricValue,
  RemoteOptionalValue,
  InsightsMetricSelectOption,
  RemoteFilterOptionalValues,
} from '../analytics.types';
import _map from 'lodash/map';
import _filter from 'lodash/filter';

export default function convertOptionalValues<G extends DimensionValue | MetricValue>(
  dataToConvert: RemoteOptionalValue<G>[],
  skipDateDimensionOnly = false,
): InsightsMetricSelectOption<G>[] {
  return _map(dataToConvert, (option: RemoteOptionalValue<G>) => {
    const {uiName: label, value, unsupportedDimensions, supportedMetrics, category} = option;

    let dimensions = [];

    if (skipDateDimensionOnly) {
      dimensions = [DimensionValue.Date].includes(value as DimensionValue)
        ? []
        : _filter(unsupportedDimensions, (dimension) => ![DimensionValue.Date].includes(dimension));
    } else {
      dimensions = DATE_DIMENSIONS.includes(value as DimensionValue)
        ? []
        : _filter(unsupportedDimensions, (dimension) => !DATE_DIMENSIONS.includes(dimension));
    }

    return {
      ...option,
      value,
      label,
      category,
      unsupportedDimensions: dimensions,
      supportedMetrics,
      ...(option.children && {
        children: _map(option.children, (child: RemoteFilterOptionalValues) => {
          const {uiName: label, value} = child;

          return {value, label};
        }),
      }),
    };
  }) as InsightsMetricSelectOption<G>[];
}
